import React from 'react';
import './MarketingSection.css';

const imageSets = [
  ['/images/01 Durex-EnergyDrink.jpg', '/images/02 USQ-KidsUnited-SchoolOut-KV.jpg', '/images/03 MarinaSquare-ProMembership.jpg'],
  ['/images/01 Velocity-StreetEasy.jpg', '/images/02 WG-BeautyCampaign.jpg', '/images/03 ANW.jpg'],
  ['/images/01 PHxMonopoly-FoodVouchers.jpg', '/images/02 Raffles-TennisModel.jpg', '/images/03 Raffles-CarModel.jpg'],
];

function MarketingSection() {
  return (
    <section className="marketing-section container-fluid">
      <div className="row d-flex align-items-center">
        {/* Left Text Column */}
        <div className="col-md-6 marketing-text">
          <div className="marketing-title">
                {[
                    { text: 'B', color: '#ed448d' },
                    { text: 'r', color: '#5fc2a2' },
                    { text: 'i', color: '#f6953d' },
                    { text: 'n', color: '#f28aa6' },
                    { text: 'g', color: '#f38166' },
                    { text: '\u00A0', color: '' },
                    { text: 'y', color: '#6e54a3' },
                    { text: 'o', color: '#ed448d' },
                    { text: 'u', color: '#5fc2a2' },
                    { text: 'r', color: '#f6953d' },
                    { text: '\u00A0', color: '' },
                    { text: 'm', color: '#f28aa6' },
                    { text: 'a', color: '#f38166' },
                    { text: 'r', color: '#6e54a3' },
                    { text: 'k', color: '#ed448d' },
                    { text: 'e', color: '#5fc2a2' },
                    { text: 't', color: '#f6953d' },
                    { text: 'i', color: '#f28aa6' },
                    { text: 'n', color: '#f38166' },
                    { text: 'g', color: '#6e54a3' },
                    { text: '\n', color: '' },
                    { text: 'i', color: '#ed448d' },
                    { text: 'd', color: '#5fc2a2' },
                    { text: 'e', color: '#f6953d' },
                    { text: 'a', color: '#f28aa6' },
                    { text: 's', color: '#f38166' },
                    { text: '\u00A0', color: '' },
                    { text: 't', color: '#6e54a3' },
                    { text: 'o', color: '#ed448d' },
                    { text: '\u00A0', color: '' },
                    { text: 'l', color: '#5fc2a2' },
                    { text: 'i', color: '#f6953d' },
                    { text: 'f', color: '#f28aa6' },
                    { text: 'e', color: '#f38166' },
                    { text: '.', color: '#6e54a3' },
                ].map((char, idx) =>
                    char.text === '\n' ? <br key={idx} /> : (
                    <span key={idx} style={{ color: char.color }}>{char.text}</span>
                    )
                )}
                </div>

          <div className="marketing-description">
            <p>
                The team at OMO Creative Agency, is dedicated to transforming your
                vision into reality. Compelling campaign, eye-catching visuals, or
                crafting engaging content, we're here to fuel up your marketing ideas
            </p>
            <a href="#contact">
              <button>Book a Meeting</button>
            </a>
            </div>
        </div>

        {/* Right Image Carousels */}
        <div className="col-md-6 marketing-carousel-wrapper">
          <div className="d-flex gap-3 justify-content-center marketing-carousels">
            {imageSets.map((images, index) => (
              <div
                className={`carousel-column ${index % 2 === 0 ? 'scroll-up' : 'scroll-down'}`}
                key={index}
              >
                {[...images, ...images].map((img, i) => (
                    <img key={`${index}-${i}`} src={img} alt={`Marketing ${i}`} />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default MarketingSection;
